import { render, staticRenderFns } from "./AddQuestions.vue?vue&type=template&id=a56f1c50&scoped=true&"
import script from "./AddQuestions.vue?vue&type=script&lang=js&"
export * from "./AddQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56f1c50",
  null
  
)

export default component.exports